/**
 * Created by zhengyf on 2017/12/14.
 */

; (function () {

    RfqIndexCtrl.$inject = ['request'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .controller('RfqIndexCtrl', RfqIndexCtrl);

    function RfqIndexCtrl(request) {

        var vm = this;

        var COUNTRY_FLAG_URL = '/third-part/ali-assets/flag/xx.gif';

        vm.token = DSSX.util.getToken();

        vm.d = {
            business: []
        };

        vm.f = {

        };

        init();

        function init() {
            console.log('[RfqIndexCtrl init: ]');
            loadRecommendBusiness();
        }

        // 加载推荐的商机
        function loadRecommendBusiness() {

            return request.get('/pub/api/listRecmdRfq', {}, false)
                .then(callback, errCallback);

            function callback(res) {
                var result = [];
                var bsns = DSSX.util.safe(res, 'data.rfqList', []);
                for (var i = 0; i< bsns.length; i++) {
                    var bn = {};
                    bn.subject = bsns[i].subject;
                    bn.detail = bsns[i].description;
                    bn.quantityNum = bsns[i].quantity;
                    bn.unit = 'Pieces';
                    bn.countryFlag = COUNTRY_FLAG_URL.replace("xx", bsns[i].countySimple).toLocaleLowerCase(),
                    bn.country = bsns[i].country;
                    bn.time = bsns[i].openTimeStr;
                    bn.timeZone = '(U.S. PST)';
                    bn.remainNum  = bsns[i].rfqLeftCount;
                    bn.key = bsns[i].keyword === 'dress' ? 'dress' + (i + 1) : 'shoes' + (i + 1);
                    bn.rfqId = bsns[i].id;
                    result.push(bn);
                }

                vm.d.business = result;
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'RFQ市场',
                    funcName: 'loadRecommendBusiness',
                    text: '加载推荐的商机失败'
                });
            }

        }


    }

})();
